import React, { useState } from "react";
import { Container, Row, Col, Tooltip } from "reactstrap";

import { isLocal, isDev } from "../utils/env";

const style = {
  backgroundColor: "orange",
  color: "white",
};

let ENV_TEXT = null;
if (isDev()) {
  ENV_TEXT = "QA";
}
if (isLocal()) {
  ENV_TEXT = "Local";
}

export default function EnvHeader() {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    ENV_TEXT && (
      <Container fluid style={style}>
        <Row className="w-100" id="env-tooltip">
          <Col className="text-center">
            <h5 className="text-white pt-2">{ENV_TEXT} ENV</h5>
          </Col>
        </Row>
        <Tooltip placement="bottom" isOpen={tooltipOpen} target="env-tooltip" toggle={toggle}>
          You are currently logged into the
          <br />
          {ENV_TEXT.toUpperCase()}
          <br />
          environment where communication is restricted to whitelisted recipients
        </Tooltip>
      </Container>
    )
  );
}
